import React, { Component } from 'react';

class Decvrcard extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="d-flex flex-column align-items-center mx-2 px-2  mx-lg-5 px-lg-4">
                            <img src={this.props.img} width="120px" height="120px" alt="" />
                            <span className='home__txt  sponsored decvr__links'>{this.props.title}</span>
                            <p className='decvr__txt'>{this.props.txt}</p>
                            <span className='home__txt  sponsored plus__link'>Plus</span>
            </div>
        );
    }
}

export default Decvrcard;
